import React from 'react'
import pure from 'recompose/pure'
import isEmpty from 'lodash/isEmpty'

import { getPublicUrl } from 'pmt-modules/environment'

let Flag = ({ className, country, alt = '', ...otherProps }) => {
  if (!isEmpty(country)) {
    let flagSvg

    try {
      flagSvg = getPublicUrl() + require(`./flags/${country.toLowerCase()}.svg`)
    } catch (error) {
      // Fallback with empty flag
      flagSvg = getPublicUrl() + require(`./flags/xx.svg`)
    }

    return <img className={className} src={flagSvg} alt={alt} {...otherProps} />
  }
}

Flag = pure(Flag)
Flag.displayName = 'Flag'

export default Flag
